import React, { useRef } from "react";
import clsx from "clsx";
import loadable from "@loadable/component";

import styles from "./Footer.styles";

const Container = loadable(() => import("@material-ui/core/Container"));
const Row1 = loadable(() => import("./Row1"));
const Row2 = loadable(() => import("./Row2"));
const Row3 = loadable(() => import("./Row3"));

const Footer = () => {
	const containerRef = useRef();
	const css = styles();

	return (
		<div className={clsx(css.footer, "mco-view-component-footer")}>
			<Container
				className={clsx(css.container, "mco-view-component-footer__container")}
				maxWidth="lg"
				ref={containerRef}
			>
				<Row1 />
				<Row2 containerRef={containerRef} />
				<Row3 />
			</Container>
		</div>
	);
};

export default Footer;
